SWITCH_LANGUAGE_OUTLINE